import { temAcesso } from '@/shared/auth/temAcesso'

const Pleitos = () => import('./Pleitos.vue')
const Detalhes = () => import('./PleitosDetalhar.vue')
const PleitoForm = () => import('../componentes/PleitoForm.vue')

export default {
    path: 'pleitos/ucic',
    name: 'Pleitos_Ucic',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    beforeEnter: (to, from, next) => {
        if (temAcesso('PLEITOS-UCIC-00')) {
            next()
        }
    },
    children: [
        {
            path: '/pleitos/ucic',
            name: 'Pleitos_Ucic',
            component: Pleitos,
            beforeEnter: (to, from, next) => {
                if (temAcesso('PLEITOS-UCIC-00')) {
                    next()
                }
            }
        },
        {
            path: '/pleitos/ucic/:pleitoId',
            name: 'Pleitos_Ucic_Detalhar',
            component: Detalhes,
            beforeEnter: (to, from, next) => {
                if (temAcesso('PLEITOS-UCIC-00')) {
                    next()
                }
            }
        },
        {
            path: '/pleitos/inserir',
            name: 'Pleitos_Ucic_Inserir',
            component: PleitoForm,
            beforeEnter(to, from, next) {
                if (temAcesso('PLEITOS-UCIC-01')) {
                    next();
                }
            }
        },
        {
            path: '/pleitos/atualizar/:pleitoId',
            name: 'Pleitos_Ucic_Atualizar',
            component: PleitoForm,
            beforeEnter(to, from, next) {
                if (temAcesso('PLEITOS-UCIC-01')) {
                    next();
                }
            }
        }, 
    ]
}
